import {
    SIGNED_IN,
    SIGNED_OUT,
    ADD_USER_TYPE,
    UPDATE_USER_TYPE,
    REMOVE_USER_TYPE,
    ADD_VOTE_TYPE,
    UPDATE_VOTE_TYPE,
    REMOVE_VOTE_TYPE,
  } from './types'
  
  // Authenticate
  export const signedIn = payload => {
      return {
          type: SIGNED_IN,
          payload
      }
  }
  export const signedOut = () => {
      return {
          type: SIGNED_OUT
      }
  }

// Users
export const ADD_USER = payload => {
  return {
    type: ADD_USER_TYPE,
    payload
  }
}
  
export const REMOVE_USER = payload => {
  return {
    type: REMOVE_USER_TYPE,
    payload
  }
}

export const UPDATE_USER = payload => {
  return {
    type: UPDATE_USER_TYPE,
    payload
  }
}

// Users
export const ADD_VOTE = payload => {
  return {
    type: ADD_VOTE_TYPE,
    payload
  }
}
  
export const REMOVE_VOTE = payload => {
  return {
    type: REMOVE_VOTE_TYPE,
    payload
  }
}

export const UPDATE_VOTE = payload => {
  return {
    type: UPDATE_VOTE_TYPE,
    payload
  }
}